import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
function DeleteThisSRapport(props) {
    return (
        <div>
            <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title"
            open={true} fullWidth={true} disableEscapeKeyDown={true} disableBackdropClick={true} maxWidth={"xs"}>
                <ModalHeader className="modal-box-header bg-warning text-white">
                <IntlMessages id="Remove"/>
                    <IconButton className="text-white"
                        onClick={props.handleClose}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader>
                <DialogContent dividers>
                    <div  className="row">
                    <div className="col-12">
                    <IntlMessages id="Repport.Delete.Body"/> {props.item.Name}?
                    </div>
                    </div>

                </DialogContent>
                <DialogActions>
                    <div className="col-6">
                        <div className="form-group mb-0">
                            <button type="submit" className="btn btn-default" 
                            onClick={props.handleClose} ><IntlMessages id="Cancel"/></button>
                        </div>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                        <div className="form-group mb-0">
                            <button type="submit" className="btn btn-warning text-white"
                            onClick={props.DeleteThisRapport}
                            ><IntlMessages id="Confrim"/></button>
                        </div>
                    </div>

                </DialogActions>
            </Dialog> 
        </div>
    );
}

export default DeleteThisSRapport;